import React, { useEffect, useState } from "react";
import {
  useFilterCheckin,
  type FilterCheckinContextValue,
} from "context/FilterCheckinContext";
import { Skeleton } from "@mui/material";
import { useHistory } from "react-router-dom";
import CustomPagination from "components/CustomPagination";
import {
  useListarCheckin,
  type Checkin,
} from "services/api/AppWeb_Checkin/listar_checkin";
import * as S from "./styles";
import ContainerInfo from "./components/ContainerInfo";
import CheckInItem from "./components/CheckinItem";
import FilterButtons from "./components/FilterButtons";
import NavCommon from "../../components/@navHeader";
import Message from "./components/Message";

const checkin: React.FC = () => {
  const history = useHistory();
  const { filtros, activeFilterCount, queryParams }: FilterCheckinContextValue =
    useFilterCheckin();
  const [page, setPage] = useState(1);
  const {
    data: dataListaCheckin,
    refetch: refetchListaCheckin,
    isFetching: isFetchingListaCheckin,
    isLoading: isLoadingListaCheckin,
  } = useListarCheckin({
    queryKey: `fila_checkin_${page}_${queryParams}`,
    params: `PaginaAtual=${page}&TotalItensRetorno=5${queryParams}`,
  });

  useEffect(() => {
    refetchListaCheckin();
  }, [page, filtros]);

  const renderSkeletons = () => {
    return Array(5)
      .fill(0)
      .map(() => (
        <Skeleton
          variant="rounded"
          width="100%"
          height={40}
          style={{ marginBottom: "12px" }}
        />
      ));
  };

  return (
    <S.Container>
      <NavCommon
        breadcrumbs={[{ path: "/ckeckin", name: "Checkin" }]}
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => history.push("/")}
      />
      <S.Title>Checkin</S.Title>
      <S.SpaceY space={16} />
      <S.Text>Visualize os seus últimos check-ins</S.Text>
      <S.SpaceY space={16} />
      <S.Card>
        <S.RowSpace>
          {isLoadingListaCheckin || isFetchingListaCheckin ? (
            <>
              <Skeleton variant="rounded" width="30%" height={100} />
            </>
          ) : (
            <>
              <ContainerInfo data={dataListaCheckin?.data} />
              <FilterButtons data={dataListaCheckin?.data} />
            </>
          )}
        </S.RowSpace>
        <S.SpaceY space={16} />
        <S.Body>
          {isLoadingListaCheckin || isFetchingListaCheckin ? (
            renderSkeletons()
          ) : (
            <>
              {dataListaCheckin?.data?.checkins?.map((item: Checkin) => (
                <CheckInItem
                  key={item.idCheckin}
                  data={item}
                  corretor={dataListaCheckin?.data?.corretor ?? false}
                />
              ))}
              {!dataListaCheckin?.data?.checkins ||
              dataListaCheckin.data.checkins.length === 0 ? (
                <Message message="Nenhum Checkin disponível" />
              ) : null}
            </>
          )}
        </S.Body>

        <S.Footer>
          <CustomPagination
            count={dataListaCheckin?.pagination?.quantityPages || 1}
            page={page}
            onPageChange={(_, val) => setPage(val)}
          />
        </S.Footer>
      </S.Card>
    </S.Container>
  );
};

export default checkin;
